import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3b6f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "teacher" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"200px","height":"200px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 审核 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 详情 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 拉黑 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 解除拉黑 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 可预约时间 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 课时统计 ")
const _hoisted_14 = { class: "info-avatar-container" }
const _hoisted_15 = { class: "teacher-name" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("学历信息")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "学历证明：", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("教学信息")
const _hoisted_21 = { class: "subject-tags" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("视频介绍")
const _hoisted_24 = {
  key: 0,
  class: "video-container"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "dialog-footer" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_29 = { class: "time-container" }
const _hoisted_30 = { class: "date-header" }
const _hoisted_31 = { class: "time-slots" }
const _hoisted_32 = { class: "dialog-footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_36 = { class: "dialog-footer" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_page_content = _resolveComponent("page-content")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_class_statistics_dialog = _resolveComponent("class-statistics-dialog")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_content, {
      contentTableConfig: _ctx.contentTableConfig,
      pageName: "user",
      ref: "pageContentRef",
      otherParams: _ctx.areaInfo,
      pageUrl: "/pc/userInfo/getUserList"
    }, {
      avatar: _withCtx(({ row }) => [
        _createVNode(_component_el_image, {
          src: row.avatar,
          style: {"width":"80px"},
          "preview-src-list": [row.avatar],
          "preview-teleported": true,
          fit: "cover",
          alt: ""
        }, null, 8, ["src", "preview-src-list"])
      ]),
      educationImage: _withCtx(({ row }) => [
        (row.educationImage)
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: row.educationImage,
              style: {"width":"120px"},
              "preview-src-list": [row.educationImage],
              "zoom-rate": 1.2,
              "max-scale": 7,
              "min-scale": 0.2,
              alt: ""
            }, null, 8, ["src", "preview-src-list", "zoom-rate", "min-scale"]))
          : _createCommentVNode("", true)
      ]),
      subjectList: _withCtx(({ row }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.subjectList, (item) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: item,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`${item.levelName}/${item.gradeName}/${item.subjectName}`), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      educationList: _withCtx(({ row }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.educationList, (item) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: item.id,
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatUtcString(item.startTime,
          'YYYY-MM-DD')) + " - " + _toDisplayString(_ctx.formatUtcString(item.endTime, 'YYYY-MM-DD')) + " - " + _toDisplayString(item.university) + " - " + _toDisplayString(item.educationName) + " - " + _toDisplayString(item.educationNum), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      backgroundImage: _withCtx(({ row }) => [
        (row.backgroundImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("video", {
                controls: "",
                style: {"width":"100%","height":"100%"},
                src: row.backgroundImage
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      approveStatus: _withCtx(({ row }) => [
        (row.approveStatus == 1)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (row.approveStatus == 2)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "danger"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (row.approveStatus == -1)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 2,
              type: "warning"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      operate: _withCtx((scope) => [
        (scope.row.approveStatus == -1)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.editTeacherStaus(scope.row.userId))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_hasPermi, ['system:teacher:audit']]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: ($event: any) => (_ctx.getTeacherInfo(scope.row))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (scope.row.isBlack == 'N')
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.changeTeacherBlackStatus(scope.row.userId, 'Y', scope.row.nickName))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_hasPermi, ['system:teacher:edit']]
            ])
          : _createCommentVNode("", true),
        (scope.row.isBlack == 'Y')
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "info",
              size: "small",
              onClick: ($event: any) => (_ctx.changeTeacherBlackStatus(scope.row.userId, 'N', scope.row.nickName))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_hasPermi, ['system:teacher:edit']]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "success",
          size: "small",
          onClick: ($event: any) => (_ctx.getTeacherTime(scope.row.userId))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "danger",
          size: "small",
          onClick: ($event: any) => (_ctx.delTeacher(scope.row.userId,scope.row.nickName))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 2
        }, 1032, ["onClick"])), [
          [_directive_hasPermi, ['system:teacher:delete']]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: ($event: any) => (_ctx.getTeacherStatistics(scope.row.userId))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 2
        }, 1032, ["onClick"])), [
          [_directive_hasPermi, ['system:teacher:statistics']]
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "otherParams"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.teacherInfoVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.teacherInfoVisible) = $event)),
      title: "教师详情",
      width: "700"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.teacherInfoVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.teacherDetail,
          "label-width": "100px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_avatar, {
                        size: 100,
                        src: _ctx.teacherDetail.avatar,
                        fit: "cover"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.teacherDetail.nickName), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "姓名" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.nickName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "电话" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.phonenumber), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "身份证" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.idCard), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "学历信息" }, {
                      default: _withCtx(() => [
                        (_ctx.teacherDetail.educationList && _ctx.teacherDetail.educationList.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherDetail.educationList, (edu, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "edu-item"
                                }, [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.formatUtcString(edu.startTime, 'YYYY-MM-DD')) + " - " + _toDisplayString(_ctx.formatUtcString(edu.endTime,
                    'YYYY-MM-DD')), 1),
                                  _createElementVNode("div", null, _toDisplayString(edu.university) + " - " + _toDisplayString(edu.educationName), 1),
                                  _createElementVNode("div", null, "学号：" + _toDisplayString(edu.educationNum), 1),
                                  _hoisted_18,
                                  (edu.educationImage)
                                    ? (_openBlock(), _createBlock(_component_el_image, {
                                        key: 0,
                                        src: edu.educationImage,
                                        style: {"width":"200px","height":"150px"},
                                        "preview-src-list": [edu.educationImage],
                                        fit: "cover"
                                      }, null, 8, ["src", "preview-src-list"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, "暂无学历信息"))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "教学科目" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherDetail.subjectList, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: index,
                              class: "subject-tag",
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(`${item.levelName}/${item.gradeName}/${item.subjectName}`), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        (!_ctx.teacherDetail.subjectList || _ctx.teacherDetail.subjectList.length === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "暂无教学科目"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "教龄" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.teachingAge || '未填写') + " 年", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "爽约次数" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.breakPromiseTimes || 0) + " 次", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "地址" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.address || '未填写'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.teacherDetail.remark || '无'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "视频介绍" }, {
                      default: _withCtx(() => [
                        (_ctx.teacherDetail.backgroundImage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("video", {
                                controls: "",
                                src: _ctx.teacherDetail.backgroundImage
                              }, null, 8, _hoisted_25)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "暂无视频介绍"))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "预约时间",
      width: "600"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedTimeData, (times, date) => {
            return (_openBlock(), _createElementBlock("div", {
              key: date,
              class: "date-group"
            }, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(date), 1),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(times, (time, index) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    key: index,
                    class: "time-tag",
                    effect: "plain",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(time), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.modalshow,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalshow) = $event)),
      title: "操作",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalshow = false))
          }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_38
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          style: {"max-width":"300px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "审核状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.form.radioValue,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.radioValue) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.reson,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.reson) = $event)),
                  placeholder: "请输入备注原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_class_statistics_dialog, {
      show: _ctx.classStatisticsShow,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.classStatisticsShow = false)),
      teacherId: _ctx.use_id
    }, null, 8, ["show", "teacherId"])
  ]))
}